<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c01"><a id="page01"></a>Two For One Deal</h1>
<p class="nonindent"><span class="dropcaps">I</span>t was a wedding present that the future bride and groom would never forget. During their engagement party in Tirana, Albania, the teenage lovebirds were surprised by more than just a toaster; the groom’s father and the bride’s mother fell in love and eloped. The future in-laws became wanted outlaws when they called their respective spouses asking for a divorce, during their honeymoon in Greece. The teenagers, who finally did get married, are concerned because if the couple has a child, the new groom could eventually wind up becoming his own grandfather.<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<p class="nonindent300"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"/><br/><br/></p>
<p class="nonindent300"><strong>STUDY FINDS SEX, PREGNANCY LINK.</strong><br/><br/></p>
<p class="nonindent300"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"/></p>
<div class="textbox">
<p class="nonindent100"><span class="small">—<em>Cornell Daily Sun,</em> December 7, 1995</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c01_r1.vue?0ca1913b